export var styles = {
  imageListImageWidth: 75
};
export var TEMPLATE_TYPES = {
  EXPANDABLE_LIST: 'expandable-list',
  HERO: 'hero',
  LIST: 'list',
  IMAGE_LIST: 'image-list',
  IMAGE_LIST_LARGE: 'image-list-large',
  IMAGE_GRID: 'image-grid',
  NEXT_STEPS: 'next-steps',
  TILE_SMALL: 'tile-small',
  TILES: 'tiles',
  TWO_COLUMNS: 'two-columns'
};
export var DEFAULT_IMAGE_SRC = '//cdn.nerdwallet.com/nodeapp/structured-content/simon-hattinga-verschure-5085-unsplash.jpg';